module.exports = __webpack_public_path__ + "media/images/footer/pl_efs-d039d5b79be58d478161026029ae8261.svg";